import React, { useEffect } from 'react';
import './isatransferbanner.scss';
import useFeatureVariable from '../../../FeatureFlags/useFeatureVariable';
import { useUnifiedAnalytics } from '../../../../contexts/AnalyticsWrapper';

const FEATURE_FLAG_NAME = 'EnableISATransfersMarketingNotification';
const DEFAULT_MESSAGE = `Transfer an existing Cash ISA to Investec Save and keep your tax-free wrapper. Open a 1-Year Fixed Rate Cash ISA and we'll handle the transfer for you.`;
const DEFAULT_TITLE = 'Got a Cash ISA with another provider?';
const DEFAULT_CTA_LABEL = 'Find out more';
const DEFAULT_CTA_URL = '/new-account/fisa/isa-transfer';

const IsaTransferBanner = (/** @type {{ featureEnabled: (flag: string) => boolean }} */ { featureEnabled }) => {
    const isEnabled = featureEnabled(FEATURE_FLAG_NAME);
    const title = useFeatureVariable(FEATURE_FLAG_NAME, 'ISATransferNotificationTitle') || DEFAULT_TITLE;
    const message = useFeatureVariable(FEATURE_FLAG_NAME, 'ISATransferNotificationMessage') || DEFAULT_MESSAGE;
    const ctaLabel = useFeatureVariable(FEATURE_FLAG_NAME, 'ISATransferNotificationCTALabel') || DEFAULT_CTA_LABEL;
    const ctaUrl = useFeatureVariable(FEATURE_FLAG_NAME, 'ISATransferNotificationCTAUrl') || DEFAULT_CTA_URL;
    const analytics = useUnifiedAnalytics();

    useEffect(() => {
        if (isEnabled && message && ctaUrl) {
            if (analytics) {
                analytics.trackAnalyticsPageEvent(
                    'notification view',
                    {},
                    'ISA Transfer Marketing Notification Banner',
                    'ISA_Transfer_Marketing|Page_Load|Banner_View'
                );
            }
        }
    }, [isEnabled, message, ctaUrl, analytics]);

    if (!isEnabled || !message || !ctaUrl) {
         return <></>;
    }

    const handleCtaClick = () => {
        if (analytics) {
            analytics.trackAnalyticsClickEvent(
                'notification click',
                ctaUrl,
                'dashboard',
                'ISA Transfer',
                '',
                {},
                'click',
                'ISA_Transfer_Marketing|Link_Click|Find_Out_More',
                'ISA Transfer Marketing Notification Banner'
            );
        }
        window.location.href = ctaUrl;
    };

    return (
        <div className="isa-transfer-banner">
            <div className="isa-transfer-banner__inner">
                <div className="isa-transfer-banner__icons" aria-hidden="true">
                    <svg className="isa-transfer-banner__arrow-up" width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M36.3252 1.45887C38.2704 -0.48629 41.4241 -0.48629 43.3693 1.45887L78.2357 36.3251C80.1808 38.2703 80.1808 41.424 78.2357 43.3692C76.2905 45.3143 73.1368 45.3143 71.1916 43.3692L44.8282 17.0058V74.7134C44.8282 77.4642 42.5982 79.6943 39.8473 79.6943C37.0964 79.6943 34.8664 77.4642 34.8664 74.7134V17.0058L8.50294 43.3692C6.55778 45.3143 3.40404 45.3143 1.45887 43.3692C-0.486292 41.424 -0.486292 38.2703 1.45887 36.3251L36.3252 1.45887Z" fill="#BED8D9" />
                    </svg>
                    <svg className="isa-transfer-banner__arrow-down" width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M36.3252 78.2355C38.2704 80.1806 41.4241 80.1806 43.3693 78.2355L78.2357 43.3692C80.1808 41.4241 80.1808 38.2703 78.2357 36.3252C76.2905 34.38 73.1368 34.38 71.1916 36.3252L44.8282 62.6885V4.98096C44.8282 2.23009 42.5982 7.62939e-05 39.8473 7.62939e-05C37.0964 7.62939e-05 34.8664 2.23009 34.8664 4.98096V62.6885L8.50294 36.3252C6.55778 34.38 3.40404 34.38 1.45887 36.3252C-0.486292 38.2703 -0.486292 41.4241 1.45887 43.3692L36.3252 78.2355Z" fill="#D8E8E8" />
                    </svg>
                </div>
                <div className="isa-transfer-banner__content">
                    <h2 className="isa-transfer-banner__title">{title}</h2>
                    <div className="isa-transfer-banner__body-row">
                        <p className="isa-transfer-banner__message" dangerouslySetInnerHTML={{ __html: message }} />
                        <a
                            className="isa-transfer-banner__cta"
                            onClick={handleCtaClick}
                        >
                            <span className="isa-transfer-banner__cta-label">{ctaLabel}</span>
                            <svg className="isa-transfer-banner__cta-chevron" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289Z" fill="currentColor" />
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IsaTransferBanner;
